import React, { Fragment } from 'react'
import {Link} from 'react-router-dom'

export function CMStop({
  page='site',
  language,
  setLanguage = ()=>void(0)
}) {
  return (
    <div className="c0">
      <div className="c1">
        <div className="c_ul">
          <div className="c_li">
            <a href="#"  onClick={()=>{setLanguage('en')}} className={`c_a ${language === 'en' ? 'c_a--active' : ''}`}>English</a>
          </div>
          <div className="c_li">
            <a href="#" onClick={()=>{setLanguage('ru')}} className={`c_a ${language === 'ru' ? 'c_a--active' : ''}`}>Русский</a>
          </div>
          <div className="c_li"

          >
            <img src="https://api.netlify.com/api/v1/badges/9e13df6e-4092-4463-b55f-a668c231f352/deploy-status" alt="Deploy status badge" />
          </div>
        </div>
        <div className="c_ul_left">
          <div className="c_ul">
            <div className="c_li">
              <Link to='/cms/all' className={`c_a ${page.includes('all') ? 'c_a--active' : ''}`}>Cards management
              </Link>
            </div>
            <div className="c_li">
              <Link to='/cms/pa' className={`c_a ${page.includes('pa') ? 'c_a--active' : ''}`}>Cards in PA
              </Link>
            </div>
            <div className="c_li">
              <Link to='/cms/site' className={`c_a ${page.includes('site') ? 'c_a--active' : ''}`}>Cards on website
              </Link>
            </div>
            <div className="c_li">
              <Link to='/cms/mobile' className={`c_a ${page.includes('mobile') ? 'c_a--active' : ''}`}>Cards in mobile app
              </Link>
            </div>


            {/* <div className="c_li">
              <Link to='/cms/emails' className={`c_a ${page.includes('emails') ? 'c_a--active' : ''}`}>Cards emails
              </Link>
            </div> */}


          </div>
        </div>
        <div className="c_logo">
          <div>CMS</div>
          <div className="c_logo_beta">beta</div>
        </div>
      </div>


      {page.includes('pa1') && <div className="c1 c1--2">
        <div className="c_ul">
          <div className="c_li">
            <div className={`c_a ${page.includes('_default') ? 'c_a--active' : ''}`}>Default set</div>
          </div>
          <div className="c_li">
            <div className={`c_a ${page.includes('_all') ? 'c_a--active' : ''}`}>All cards</div>
          </div>
          {/* <div className="c_li">
            <div className={`c_a ${page.includes('_ka') ? 'c_a--active' : ''}`}>KA dream</div>
          </div> */}
        </div>
      </div>}


      {page.includes('site1') && <div className="c1 c1--2">
        <div className="c_ul">
          {/* <div className="c_li">
            <div className={`c_a ${page.includes('_default') ? 'c_a--active' : ''}`}>Default set</div>
          </div>
          <div className="c_li">
            <div className={`c_a ${page.includes('_all') ? 'c_a--active' : ''}`}>All cards</div>
          </div> */}
        </div>
      </div>}


    </div>
  );
}
export function CMStopold({page='site'}) {
  return (
    <div className='c0'
    >
<div className="">

</div>

      <div className="c_ul"
      >

        {/* <div className="c_li">
          <Link to='/cms/all'className={`c_a ${page==='all' ? 'c_a--active' : ''}`}>
            All cards
          </Link>
        </div> */}
        <div className="c_li">
          <Link to='/cms/pa'className={`c_a ${page.includes('pa') ? 'c_a--active' : ''}`}>
            All cards
          </Link>
        </div>
        <div className="c_li">
          <Link to='/cms/site' className={`c_a ${page.includes('site') ? 'c_a--active' : ''}`}>
            Cards on Website
          </Link>
        </div>

{page.includes('site') && <Fragment>

        <div className="c_li">
          <Link to='/cms/site'className={`c_a ${page==='site' ? 'c_a--active' : ''}`}>
            English
          </Link>
        </div>
        <div className="c_li">
          <Link to='/cms/site_ru'className={`c_a ${page==='site_ru' ? 'c_a--active' : ''}`}>
            Russian
          </Link>
        </div>

</Fragment>}

      </div>
    </div>
  )
}
